<app-load-general [load]="isLoading"></app-load-general>
<div class="h-(--height-full) w-full flex justify-center items-center">
  <div class="box-home">
    <div class="w-full flex justify-center items-center">
      <img alt="einteligent" class="w-112.5" src="assets/icons/logo-dynamic-einteligent.svg" />
    </div>

    <div class="px-4 py-2 text-general-subtitle bg-[--brand-azul-primario] w-full rounded-lg">
      {{ 'users.labels.changePassword' | translate }}
    </div>

    <div class="grid justify-center items-center gap-4 grid-cols-1">
      <div class="w-full">
        <app-input-general
          [formControlGeneral]="newPassword"
          [label]="'users.inputs.newPassword'"
          [placeholder]="'users.inputs.newPassword'"
          [maxlength]="50"
          [type]="'password'"
        ></app-input-general>
      </div>

      <div class="w-full">
        <app-input-general
          [formControlGeneral]="confirmPassword"
          [label]="'users.inputs.confirmPassword'"
          [placeholder]="'users.inputs.confirmPassword'"
          [maxlength]="50"
          [type]="'password'"
        ></app-input-general>
      </div>
    </div>

    <div class="flex justify-center items-center gap-4 px-4">
      <button
        mat-button
        [disabled]="!newPassword.valid || !confirmPassword.valid"
        (click)="changePassword()"
        class="button-general text-center w-auto! h-12.75 mt-2"
      >
        {{ 'users.button.savePassword' | translate }}
      </button>
    </div>
  </div>

  <app-load-general [load]="isLoading"></app-load-general>
</div>
